import React from 'react';
import { Shield, Zap, Cpu, Network, Users } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: <Shield className="w-8 h-8 text-blue-400" />,
      title: "Security First",
      description: "Enterprise-grade security practices protecting your data and infrastructure"
    },
    {
      icon: <Zap className="w-8 h-8 text-cyan-400" />,
      title: "Lightning Fast",
      description: "Optimized performance and rapid deployment cycles for your applications"
    },
    {
      icon: <Cpu className="w-8 h-8 text-purple-400" />,
      title: "Scalable",
      description: "Architectures that grow seamlessly with your business needs"
    },
    {
      icon: <Network className="w-8 h-8 text-green-400" />,
      title: "Reliable",
      description: "Robust monitoring and failover systems for consistent performance"
    }
  ];

  const whyChooseUs = [
    "Expert knowledge in Jira and Atlassian products",
    "Cloud infrastructure expertise on AWS",
    "Focus on business outcomes, not just technology",
    "Tailored solutions for every department",
    "Proven track record of successful implementations",
    "Ongoing support and optimization services"
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">About DAS Cloud Engineering</h1>
            <p className="text-lg text-slate-300 max-w-3xl mx-auto leading-relaxed">
              We specialize in Atlassian solutions and cloud-native infrastructure on AWS. Our team helps organizations 
              streamline their development workflows, automate infrastructure, and build scalable, secure cloud environments.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-white mb-6">Our Mission</h2>
              <p className="text-lg text-slate-300 mb-6 leading-relaxed">
                With years of experience in enterprise cloud transformation and DevOps automation, we deliver solutions 
                that not only meet your current needs but also scale with your future growth.
              </p>
              <p className="text-lg text-slate-300 mb-8 leading-relaxed">
                Our approach combines technical expertise with strategic thinking to provide comprehensive cloud engineering 
                services that drive real business value.
              </p>
              
              <div className="grid grid-cols-2 gap-6">
                {values.map((value, index) => (
                  <div key={index} className="flex items-start">
                    <div className="flex-shrink-0 mt-1 mr-3">
                      {value.icon}
                    </div>
                    <div>
                      <div className="text-white font-semibold">{value.title}</div>
                      <div className="text-slate-400 text-sm">{value.description}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-gradient-to-br from-slate-700 to-slate-800 rounded-2xl p-8 border border-slate-600">
              <div className="text-center mb-8">
                <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <Users className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">Why Choose Us</h3>
                <p className="text-slate-300">The DAS Cloud Engineering advantage</p>
              </div>
              
              <div className="space-y-4">
                {whyChooseUs.map((item, index) => (
                  <div key={index} className="flex items-start">
                    <div className="flex-shrink-0 mt-1 mr-3 text-green-400">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                      </svg>
                    </div>
                    <div className="text-slate-300">{item}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;